import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 搜索主单
export function queryMAWB(params) {
  return request({
    url: URL.booking.mawb.queryMAWB,
    method: 'get',
    params
  })
}

// 新增主单
export function addMAWB(data) {
  return request({
    url: URL.booking.mawb.addMawb,
    method: 'post',
    data
  })
}

// 删除主单
export function deleteMAWB(params) {
  return request({
    url: URL.booking.mawb.deleteMawb,
    method: 'delete',
    params
  })
}
